import { render, staticRenderFns } from "./gps-standingbooks.vue?vue&type=template&id=e685468c&scoped=true"
import script from "./gps-standingbooks.vue?vue&type=script&lang=js"
export * from "./gps-standingbooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e685468c",
  null
  
)

export default component.exports